import { createContext, useContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

const API_URL = 'https://songmoment.onrender.com';
const AppContext = createContext();

export function AppProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('songmoment_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [token, setToken] = useState(() => {
    return localStorage.getItem('songmoment_token') || null;
  });
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const s = io(API_URL);
    setSocket(s);
    return () => s.disconnect();
  }, []);

  // Verify token on load
  useEffect(() => {
  if (token) {
    axios.get(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      // Extract username from user_metadata if not at top level
      const userData = res.data;
      const normalized = {
        ...userData,
        username: userData.username || userData.user_metadata?.username || userData.email,
      };
      setUser(normalized);
      localStorage.setItem('songmoment_user', JSON.stringify(normalized));
    }).catch((err) => {
  if (err?.response?.status === 401) {
    logout();
  }
});
  }
}, []);

  const signup = async (email, password, username) => {
  const res = await axios.post(`${API_URL}/api/auth/signup`, {
    email, password, username
  });
  const { user, session, emailConfirmationRequired } = res.data;

  // ✅ If email verification needed, don't log in yet
  if (emailConfirmationRequired) {
    return { emailConfirmationRequired: true };
  }

  setUser({ ...user, username });
  setToken(session?.access_token);
  localStorage.setItem('songmoment_user', JSON.stringify({ ...user, username }));
  localStorage.setItem('songmoment_token', session?.access_token);
  return user;
};

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/api/auth/login`, {
      email, password
    });
    const { user, session } = res.data;
    setUser(user);
    setToken(session?.access_token);
    localStorage.setItem('songmoment_user', JSON.stringify(user));
    localStorage.setItem('songmoment_token', session?.access_token);
    return user;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('songmoment_user');
    localStorage.removeItem('songmoment_token');
  };

  return (
    <AppContext.Provider value={{ user, token, socket, signup, login, logout }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);